module.exports = __webpack_public_path__ + "img/import.a5b5117a.svg";